import { useState, useEffect } from 'react'
import Switch from './reusable/Switch';
import text from '../lib/dictionary.json';
import PasswordIcon from '@mui/icons-material/Lock';
import ChangePassword from "../pages/ChangePassword";
import { useAuth } from '../AuthProvider';
import { useNavigate } from "react-router";
import { UserIcon } from '../Icons';
import ArrowForwardIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import ArrowBackIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import MyProfile from '../pages/MyProfile';

const MAX_TEXT_LENGTH = 30;

const UserSettings = () => {
    const {
        user,
        setUser,
        lang,
        setLang,
        openSettings,
        setOpenSettings
    } = useAuth();
    const [changePassword, setChangePassword] = useState({
        open: false,
        userId: 0
    });

    const [showMyProfile, setShowMyProfile] = useState({
        open: false,
        userId: 0
    });
    const navigate = useNavigate();

    useEffect(() => {
        const nameTypeText = user.name;
        const nameTypeField = document.getElementById('user-name-type');
        const emailField = document.getElementById('user-email');
        emailField.innerText = user.email?.length > MAX_TEXT_LENGTH
            ? user.email?.substring(0, MAX_TEXT_LENGTH) + '...'
            : user.email;
        nameTypeField.innerText = nameTypeText?.length > MAX_TEXT_LENGTH
            ? nameTypeText?.substring(0, MAX_TEXT_LENGTH) + '...'
            : nameTypeText;
    }, [user.email, user.name, user.type]);

    return (
        <div id="settings-modal" style={{
            opacity: Number(openSettings),
            top: openSettings ? 0 : `calc(-100%)`
        }} onClick={() => setOpenSettings(false)}>
            {changePassword.open
                ? <ChangePassword state={changePassword} setState={setChangePassword} />
                : null}

            {showMyProfile.open
                ? <MyProfile state={showMyProfile} setState={setShowMyProfile} />
                : null}
                
            <div id="settings-popup" style={{
                [lang === 'en' ? 'right' : 'left']: 24,
            }} onClick={(e) => e.stopPropagation()}>
                <div className="settings-modal-header"
                // style={{ flexDirection: lang === 'en' ? 'row' : 'row-reverse' }}
                >
                    <UserIcon style={{ transform: `scaleX(${lang === 'en' ? '' : '-'}1)` }} />
                    <div className="settings-modal-user" style={{ textAlign: lang === 'en' ? 'left' : 'right' }}>
                        <h4 id="user-name-type"> </h4>
                        
                        <span id="user-email" className="settings-modal-email"></span>
                    </div>
                </div>
                <div className='separator' style={{ height: 1 }}></div>
                <div className="settings-modal-content">
                    <div className="settings-modal-item"
                        // style={{ flexDirection: lang === 'en' ? '' : 'row-reverse' }}
                        onClick={() => setShowMyProfile({ open: true, userId: user.id })}>
                        <span>{text[lang]['profile']}</span>
                        {lang === 'en' ? <ArrowForwardIcon /> : <ArrowBackIcon />}
                    </div>
                    <div className="settings-modal-item"
                        style={{
                            //  flexDirection: lang === 'en' ? '' : 'row-reverse',
                            borderRadius: 0
                        }} onClick={
                            () => setChangePassword({ open: true, userId: user.id })}>
                        <span>{text[lang]['change-password']}</span>
                        <PasswordIcon />
                    </div>
                    <div className="settings-modal-item" style={{
                        // flexDirection: lang === 'en' ? '' : 'row-reverse',
                        borderRadius: 0
                    }}>
                        <span>{text[lang]['app-lang']}</span>
                        <Switch
                            small
                            value={lang === 'ar'}
                            label={''}
                            onIcon={<div className='toggle-icon'>AR</div>}
                            offIcon={<div className='toggle-icon'>EN</div>}
                            handler={() => {
                                const newLang = lang === 'ar' ? 'en' : 'ar';
                                setLang(newLang);
                                setUser({
                                    ...user,
                                    settings: user.settings ? {
                                        ...user.settings,
                                        others: { ...user.settings.others, lang: newLang }
                                    } : { others: { lang: newLang } }
                                });
                            }} alignment={lang === 'en'} />
                    </div>

                    <div className="settings-modal-item" style={{
                        //  flexDirection: lang === 'en' ? '' : 'row-reverse',
                        borderRadius: 0
                    }}>
                        <span>{text[lang]['role']}</span>
                        <span className='settings-modal-value'>{user.type}</span>
                    </div>
                </div>
                <div className='separator' style={{ height: 1 }}></div>
            </div>
        </div>
    );
};

export default UserSettings;